import QueryFieldKey from '@opsbase/lib-data-queryfield/QueryFieldKey';
import View from '@opsbase/lib-data-view/View';
import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import useViewRegistry from '@opsbase/web-ctrl-view/useViewRegistry';
import useViewRegistryActions from '@opsbase/web-ctrl-view/useViewRegistryActions';
import DVLPage from '@opsbase/web-dvl-page';
import Vertical from '@opsbase/web-layout/Vertical';
import React, { useCallback, useEffect } from 'react';
import IssueMenu from '../../menus/IssueMenu';
import IssuesSelectionToolbar from '../../toolbars/IssuesSelectionToolbar';
export function OpDefinitionEditIssuesTab(props) {
    const { opDefinition, disabled } = props;
    const viewRegistry = useViewRegistry();
    const { putView } = useViewRegistryActions();
    const viewId = 'issuesFor' + opDefinition.id;
    useEffect(() => {
        if (!viewRegistry[viewId]) {
            const allissues = viewRegistry['allissues'];
            const view = new View({
                id: viewId,
                title: allissues.title,
                type: allissues.type,
                fields: allissues.fields,
                groupBys: [],
                filters: [],
                sortBy: allissues.sortBy.key,
                sortByDesc: allissues.sortByDesc,
            });
            // If OpDef Log
            view.filters.push({
                queryFieldKey: QueryFieldKey.OPDEFINITION,
                id: opDefinition.id,
                title: opDefinition.title,
                frozen: true,
                hidden: true,
                veryHidden: true,
            });
            view.groupBys.push({ queryFieldKey: QueryFieldKey.ISSUE_STATUS });
            putView(view, true);
        }
    }, [viewId, viewRegistry, opDefinition, putView]);
    const fieldSelector = useCallback((a) => a.filter(z => z.key !== QueryFieldKey.OPDEFINITION), []);
    return (React.createElement(Vertical, null,
        React.createElement(DVLPage, { key: "issueslog", viewId: viewId, itemPage: Pages.ISSUES_VIEW, itemMenu: IssueMenu, disableSaving: true, disableOpsMenu: true, notFoundText: i18n.t('no-issues-found'), itemSelectionToolbar: React.createElement(IssuesSelectionToolbar, { disabled: disabled }), fieldSelector: fieldSelector })));
}
export default OpDefinitionEditIssuesTab;
